
import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class CheckOption extends Vue {
  @Prop({ required: true, default: 'id' }) readonly id!: string
  @Prop({ required: true, default: 'name' }) readonly name!: string
  @Prop({ required: true, default: '' }) readonly label!: string
}
